import { userAgreements } from './agreements-reducer';

interface AgreementsState {
  isEulaAgreed?: boolean;
  agreementId?: string;
  [key: string]: unknown;
}

const initialState: AgreementsState = {};

export function AgreementsReducer(
  state: AgreementsState = initialState,
  action: { type: string; payload?: unknown },
): AgreementsState {
  return userAgreements(state, action);
}
